/**
 * Narrows a `?redirectTo=` to somewhere inside this app.
 *
 * Every auth screen takes a destination from the URL, which is exactly the
 * shape of an open redirect: a link to our own sign-in page that lands on
 * someone else's, with our domain in the address bar up to the last moment.
 * Anything that is not a plain absolute path is discarded rather than repaired.
 *
 * The fallback is the home page. It used to be `/notes`, which was the
 * template's one end-to-end vertical and the address a signed-in person landed
 * on by default — a screen this product never had a use for (`prd/ROADMAP.md`,
 * A16).
 */
export function internalPath(value: string | undefined, fallback = '/'): string {
  if (!value) return fallback;

  // `//evil.com` and `/\evil.com` are both protocol-relative to a browser, and
  // `https://…` needs no explanation. A single leading slash is the whole rule.
  if (!value.startsWith('/') || value.startsWith('//') || value.startsWith('/\\')) return fallback;

  return value;
}
